import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import fireDebugWarning from 'flarum/common/helpers/fireDebugWarning';
import Link from 'flarum/common/components/Link';

function blurOnClick(e: MouseEvent) {
  e.currentTarget.blur();
}

export default class CustomHeader extends Component {
  addLinks: boolean = false;

  view() {
    return (
      <>
        <header class="Bhasvic-CustomNavBar">{this.items().toArray()}</header>
      </>
    );
  }

  link(link: string, args?: Record<string, unknown>) {
    return this.addLinks ? app.route(link, args) : '#';
  }

  items(): ItemList {
    const items = new ItemList();

    // We should exit early if the blog ext is not enabled.
    if (!('v17development-blog' in flarum.extensions)) {
      fireDebugWarning('[B-Mag Theme] `v17development/flarum-blog` is not activated, so the nav bar cannot be correctly rendered.');
      return items;
    }

    // This navbar shows all links from FoF/Links with our custom styling.

    // Fetch all Links from the store
    const links = app.store.all('links');

    /**
     * Root links
     */
    const headerLinks: any[] = [];
    /**
     * Map of root link IDs to all their child links.
     */
    const childLinks: Record<string, any[]> = {};

    // Populate our variables
    links.forEach((link: any) => {
      if (link.isChild()) {
        const parentId = link.parent().id();

        if (!(parentId in childLinks)) {
          childLinks[parentId] = [];
        }

        childLinks[parentId].push(link);
      } else {
        headerLinks.push(link);
      }
    });

    // Find the highest position -- we'll need this to correctly order by their position in the admin dashboard
    const highestPosition = Math.max(...headerLinks.map((link) => link.position()));

    // Create link elements
    headerLinks.forEach((link) => {
      const thisChildLinks = childLinks[link.id()] || [];

      // Create dropdown children (child links)
      const children = thisChildLinks
        .sort((a, b) => a.position() - b.position())
        .map((link) => (
          <Link href={link.url()} onclick={blurOnClick}>
            {link.title()}
          </Link>
        ));

      items.add(
        link.id(),
        <Link href={link.url()} onclick={blurOnClick} data-link-id={link.id()}>
          {link.title()}
          {!!children.length && <div class="NavBar-Dropdown">{children}</div>}
        </Link>,
        highestPosition - link.position()
      );
    });

    return items;
  }

  static mount() {
    const container = document.getElementById('bhasvic-header');

    // Fail safely if the container isn't found
    if (!container) return;

    // Mount this component to the `#bhasvic-navbar` container
    m.mount(container, CustomHeader);
  }

  oncreate(): void {
    this.addLinks = true;
  }
}
